import { Injectable } from '@angular/core';
import { Snack, SnackData, SnackTheme } from '@main/snackbar/const';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as SnackbarActions from '../store/actions';
import { SnackbarSelectors } from '../store/selectors';
import { StateWithSnackbar } from '../store/snackbar-state';

@Injectable({
  providedIn: 'root',
})
export class SnackbarFacade {
  constructor(protected store: Store<StateWithSnackbar>) {}

  setSnack(snack: SnackData): void {
    const id = '_' + Math.random().toString(36).substring(2, 11);
    snack.delay = snack.delay ? snack.delay : 5000;
    snack.theme = snack.theme ? snack.theme : SnackTheme.Dark;
    this.store.dispatch(new SnackbarActions.SetSnack({ id: id, ...snack }));
  }

  getSnackbar(): Observable<Snack[]> {
    return this.store.pipe(select(SnackbarSelectors.getSnackbar));
  }

  removeSnack(id: string): void {
    this.store.dispatch(new SnackbarActions.RemoveSnack(id));
  }

  closeSnack(snack: Snack): void {
    this.store.dispatch(new SnackbarActions.CloseSnack(snack));
  }

  /**
   * Удаляет все снеки, которые удовлетворяют условиям matchFunc.
   * Обратите внимание что при удалении снеков данным способом,
   * функция onClose (переданная в пропсах при создании снека) не
   * вызывается.
   */
  removeAll(matchFunc: (snack: Snack) => boolean): void {
    this.store.dispatch(new SnackbarActions.RemoveAll(matchFunc));
  }

  getSnackbarHidden(): Observable<boolean> {
    return this.store.pipe(select(SnackbarSelectors.getSnackbarHidden));
  }

  hideSnackbar(): void {
    this.store.dispatch(new SnackbarActions.HideSnackbar());
  }
}
